
import { Suspense, lazy } from 'react';
import Loader from '../custom/loader/main';


const Main = lazy(() => import('../components/configure/location/main'))

const Locations = () => {
    return(
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )
}

export default Locations;